const countryNameMap = { PE: "Peru", CL: "Chile", MX: "Mexico" };

function createCutomerAccount(
  accountName,
  accountId,
  country,
  accountCode,
  entityId,
  fatherAccount
) {
  return {
    accountName,
    accountId,
    country,
    countryName: countryNameMap[country],
    accountCode,
    entityId,
    fatherAccount: fatherAccount && fatherAccount !== "" ? fatherAccount : null,
  };
}

function getCustomerAccount(account) {
  return createCutomerAccount(
    account.account_name,
    account.account_id,
    account.country,
    account.account_code,
    account.entity_id,
    account.father_account
  );
}

export default function getNormalizeData(accounts) {
  return accounts.map(getCustomerAccount);
}
